<template>
  <v-list-item-content>
    <v-list-item-title>
      {{ label }}
      <span v-if="badge" class="text-caption ml-1">· {{ badge }}</span>
    </v-list-item-title>
  </v-list-item-content>
</template>

<script>
const { iscoOccupationBadge } = require('../lib/catalog-autocomplete')

export default {
  name: 'CatalogSuggestionItem',
  props: {
    item: { default: null }
  },
  computed: {
    label() {
      if (this.item && typeof this.item === 'object') return this.item.label || ''
      return this.item == null ? '' : String(this.item)
    },
    badge() {
      return iscoOccupationBadge(this.item)
    }
  }
}
</script>
